import React, { useState, useEffect } from 'react';
import LoadingSpinner from '../../Helpers/LoadingSpinner';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import Mensaje from '../../Models/Mensaje';
import DowngradeAviso from '../../Components/Features/UpSelling/DowngradeAviso';
import { CambioPlanCodigo } from '../../Models/CambioPlanCodigo';
import Deuda from '../../Components/Common/Banners/Deuda';
import CallCenter from '../../Components/Features/UpSelling/CallCenter';
import SinSuscripcionDigital from '../../Components/Features/UpSelling/SinSuscripcionDigital';
import { trackPage } from '../../Helpers/UpsellingTracker';
import Toast from '../../Components/Common/Modules/Toast';
import '../../Statics/Scss/Pages/UpsellingConfirmar.scss';
import useGetInfoPlanUpselling from '../../Hooks/useGetInfoPlanUpselling';
import Planes from '../../Components/Features/UpSelling/Planes';
import useConfirmarCambioUpselling from '../../Hooks/useConfirmarCambioUpselling';
import Breadcrumb from '../../Components/Common/Modules/Breadcrumb';
import TitleWeb from '../../Components/Common/Web/Title';
import { getUpsellingNombresAmigables } from '../../Config/UpsellingNombresAmigables';
import ConfigUpselling from '../../Config/UpsellingConfig';
import UrlProperties from '../../Helpers/UrlProperties';
import PathsConfig from '../../Config/RoutePaths';

const UpsellingConfirmar = () => {
    const history = useHistory();
    const [infoUpselling, errorInfoUpselling, loadingInfoUpselling, getInfoUpselling] = useGetInfoPlanUpselling();
    const [errorConfirmarUpselling, loadingConfirmarUpselling, confirmarUpselling] = useConfirmarCambioUpselling();
    const { pathname } = useLocation();
    const { campania, plan } = useParams();
    const pathUpselling = pathname.split('confirmar-upselling')[1];
    const planUp = plan ? Object.values(ConfigUpselling.campania.planes.find(planx => Object.keys(planx) == plan ))[0] : null;

    const IdCanalDeVenta = UrlProperties.getParam('cv');
    const IdFormaDeContacto = UrlProperties.getParam('fc');

    useEffect(() => {
        if (!planUp) {
            history.push({pathname: PathsConfig.MisSuscripciones});
        } else {
            getInfoUpselling({ campania: ConfigUpselling.campania.id, plan:planUp.id , pathUpselling });
        }
    }, []);

    const PageState = (data) => {
        if (data == null || !data || data.Codigo == null) return null;

        let result = null;
        switch (data.Codigo) {
            case CambioPlanCodigo.ERROR_DATOS:
                result = <Toast status="warning" closeAuto={3000} title={Mensaje.getError('GENERAL')} />;
                break;
            case CambioPlanCodigo.OK:
                result = (
                    <Planes
                        NombreActual={data.NombreActual}
                        NombreUpsell={data.NombreUpsell}
                        CantidadCredencialesActual={data.CantidadCredencialesActual}
                        CredencialesPlanUpsell={data.CredencialesPlanUpsell}
                        PrecioActual={data.PrecioActual}
                        PrecioUpsell={data.PrecioUpsell}
                        Tarjeta={data.Tarjeta}
                        CredencialCategoria={data.CredencialCategoria}
                        PlanDeVenta={data.PlanDeVenta}
                        ConfirmarPlan={() => {
                            confirmarUpselling(ConfigUpselling.campania.id, 
                                                planUp.id, 
                                                data.NombreUpsell, 
                                                pathUpselling, 
                                                infoUpselling, 
                                                IdCanalDeVenta ? IdCanalDeVenta : ConfigUpselling.campania.canalVentaDefault, 
                                                IdFormaDeContacto ? IdFormaDeContacto : ConfigUpselling.campania.formaContactoDefault);
                        }}
                    />
                );
                break;
            case CambioPlanCodigo.USUARIO_INVALIDO:
                trackPage('upselling_usuario_no_valido', pathUpselling, data);
                result = <SinSuscripcionDigital />;
                break;
            case CambioPlanCodigo.DEUDA:
                result = <Deuda />;
                break;
            case CambioPlanCodigo.CALL_CENTER:
                result = <CallCenter />;
                break;
            case CambioPlanCodigo.DOWNSALE:
                result = <DowngradeAviso nombreActual={data.NombreActual} />;
                break;
        }
        return result;
    };

    return (
        <>
            <LoadingSpinner isLoading={loadingInfoUpselling || loadingConfirmarUpselling}>
                <section>
                    <Breadcrumb
                        firstItem="Mis suscripciones"
                        secondItem={`Cambiando a ${getUpsellingNombresAmigables[plan]}`}
                        text="Ver suscripciones"
                        href="#"
                    />
                    <TitleWeb text={`Cambiando a ${getUpsellingNombresAmigables[plan]}`} />
                </section>
                {(errorInfoUpselling || errorConfirmarUpselling) && <Toast status="warning" title={errorInfoUpselling || errorConfirmarUpselling} />}
                {infoUpselling && PageState(infoUpselling)}
            </LoadingSpinner>
        </>
    );
};

export default UpsellingConfirmar;
